import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqList } from "@/mocks/content";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-3xl mx-auto">
        <SectionHeading
          eyebrow="FAQ"
          title="影迷常见问题"
          desc="关于站内内容与观看方式的一些说明，点击问题即可展开查看。"
          align="center"
        />

        <div className="mt-10 md:mt-14 space-y-3">
          {faqList.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className={`rounded-lg border bg-background-100 overflow-hidden transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-sm md:text-base font-medium text-foreground-950">
                      {item.q}
                    </span>
                    <span
                      className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-full transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      <i
                        className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`}
                      />
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600 border-t border-background-200 pt-4">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}